import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

// Order Ops → Catalog — no rider (backend: routers/catalog_courier.py).
export async function listCourierOrders() {
  const res = await axios.get(`${API_BASE}/catalog-courier/orders`, { headers: authHeader() });
  return res.data; // { rider_lookup_failed, orders: [...] }
}

export async function setCourierItems(appointmentId, barcodes) {
  const res = await axios.post(`${API_BASE}/catalog-courier/${appointmentId}/items`, { barcodes }, { headers: authHeader() });
  return res.data;
}

export async function requestAppPayment(appointmentId) {
  const res = await axios.post(`${API_BASE}/catalog-courier/${appointmentId}/request-payment`, {}, { headers: authHeader() });
  return res.data;
}

export async function markCourierPaid(appointmentId, utr) {
  const res = await axios.post(`${API_BASE}/catalog-courier/${appointmentId}/mark-paid`, { utr }, { headers: authHeader() });
  return res.data;
}

export async function markCourierRto(appointmentId, reason) {
  const res = await axios.post(`${API_BASE}/catalog-courier/${appointmentId}/mark-rto`, { reason }, { headers: authHeader() });
  return res.data;
}

export async function lookupCourierPiece(barcode) {
  const res = await axios.get(`${API_BASE}/catalog-courier/lookup/${encodeURIComponent(barcode)}`, { headers: authHeader() });
  return res.data; // { item_id, zoddle_barcode, status, size, design_name, image_url, brand, price, sold }
}
